// extracted by extract-css-chunks-webpack-plugin
module.exports = {"video":"_1w0gKv","actions":"_1hWXY_","playbtn":"_10aXj7","title":"sNPe2g","centerWrap":"njLL-k","button":"_3i2-4K","hovering":"_2e8zCw"};